import {FC, useState} from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { LogoBrand } from "../../assets";
import { PUBLIC_HEADER, PUBLIC_SUB_HEADER } from "../../constants/headerLinks";
import { HeaderElementType } from "../../types";
import SSOLoginButton from "src/pages/login/SSOLoginButton";
import {FAX_NUMBER, PHONE_NUMBER} from "../../constants/contact";



const GuestHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [openSubmenus, setOpenSubmenus] = useState<number[]>([]);



  return (
      <>
      <nav className="navbar top-head bg-primary">
          <div className="container">
              <ul className="navbar-nav justify-content-around justify-content-md-end">
                {PUBLIC_HEADER.map((headerLink, index) => (
                    <li className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                        key={index}>
                        {headerLink.actionType === HeaderElementType.ROUTE ? (
                            <Link className="nav-link" aria-current="page"
                                to={headerLink.redirectLink}>{headerLink.title}</Link>
                        ) : null}
                        {headerLink.actionType === HeaderElementType.BUTTON ? (
                            <button className="btn btn-localCoverage rounded-2 custom-text-purple"
                                    style={{fontStyle: 'italic', fontWeight: 'bold'}} onClick={() => {
                                navigate(headerLink.redirectLink)
                            }}>
                                {headerLink.title}
                            </button>
                        ) : null}
                        {headerLink.actionType === HeaderElementType.LINK ? (
                            <a className="nav-link" href={headerLink.redirectLink} target="_blank"
                                rel="noreferrer">
                                {headerLink.title}
                            </a>
                        ) : null}
                        {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                            <>
                                <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    {headerLink.title}
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end">
                                    {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                                        <li key={index}>
                                            <a className="dropdown-item" href={header.redirectLink}
                                                target="_blank" rel="noreferrer">
                                                {header.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        ) : null}
                    </li>
                ))}
              </ul>
          </div>
      </nav>
      <nav className="navbar navbar-expand-lg py-2 py-lg-3">
          <div className="container">
              <Link className="navbar-brand" to="/users/sign_in"><img src={LogoBrand} alt="Flexion Logo"/></Link>
              <button className="navbar-toggler bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#hubHeader">
                  <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse justify-content-start" id="hubHeader">
                  <ul className="navbar-nav">
                      {PUBLIC_SUB_HEADER.map((headerLink, index) => (
                          <li className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                              key={index}>
                              {headerLink.actionType === HeaderElementType.ROUTE ? (
                                  <Link className="nav-link" aria-current="page"
                                        to={headerLink.redirectLink}>{headerLink.title}</Link>
                              ) : null}
                              {headerLink.actionType === HeaderElementType.BUTTON ? (
                                  <button className="btn btn-localCoverage" onClick={() => {navigate(headerLink.redirectLink)}}>
                                      {headerLink.title}
                                  </button>
                              ) : null}
                              {headerLink.actionType === HeaderElementType.LINK ? (
                                  <a className="nav-link" href={headerLink.redirectLink} target="_blank">
                                      {headerLink.title}
                                  </a>
                              ) : null}
                              {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                                  <>
                                      <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                                         aria-expanded="false">
                                          {headerLink.title}
                                      </a>
                                      <ul className="dropdown-menu dropdown-menu-end">
                                          {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                                              <li key={index}>
                                                  <a className="dropdown-item" href={header.redirectLink}
                                                     target="_blank" rel="noreferrer">
                                                      {header.title}
                                                  </a>
                                              </li>
                                          ))}
                                      </ul>
                                  </>
                              ) : null}
                          </li>
                      ))}
                  </ul>
                  <div className="ms-auto d-flex align-items-start flex-column flex-lg-row align-items-lg-center">
                      <div className="phone-fax-holder d-flex flex-column me-4">
                          <p className="m-0"><i className="bi bi-telephone"></i> {PHONE_NUMBER}</p>
                          <p className="m-0"><i className="bi bi-printer"></i> {FAX_NUMBER}</p>
                      </div>
                      <SSOLoginButton/>
                  </div>
              </div>
          </div>
      </nav>
      </>
  );
};

export default GuestHeader;
